import 'jquery';
import 'slick-carousel';
import '@fancyapps/fancybox';
import 'vivus';
import './map';
import Player from '@vimeo/player';

window.appJs = {};

(function (appJsApp) {

    /* ==========================================================================
      Global functions
       ========================================================================== */

    appJsApp.InitializeHeroDiscoverSlider = function () {
        if (document.querySelector('.js-hero-discover-slider')) {
            $('.js-hero-discover-slider').slick({
                fade: false,
                arrows: true,
                dots: false,
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation" id="slick-prev-icon"><use xlink:href="#icon-arrow-left"></use></svg></button>',
                nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation" id="slick-next-icon"><use xlink:href="#icon-arrow-right"></use></svg></button>',
                appendArrows: $(".hero-discover-slider__arrows"),
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
                ]
            });
        }
    }

    appJsApp.ClearHeroDiscoverSlider = function () {
        if (document.querySelector('.js-hero-discover-slider')) {
            $(".js-hero-discover-slider").slick('unslick');
            $('.hero-discover-slider__slide').remove();
        }
    }

    $(document).ready(function () {
            appJsApp.InitializeHeroDiscoverSlider();

            /* ==========================================================================
            Fade in elements with intersection observer
            ========================================================================== */

            if ('IntersectionObserver' in window) {
                var observer = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting === true) {
                            entry.target.classList.add("fade-in--is-visible");
                        } else {
                            //entry.target.classList.remove("fade-in--is-visible");
                        }
                    });
                });
                var items = document.querySelectorAll(".fade-in");
                items.forEach(function (item, index) {
                    observer.observe(item, index);
                });
            } else {
                document.querySelector("body").classList.add("no-intersection-observer")
            }

            /* ==========================================================================
               Mobile Menu Button
               ========================================================================== */

            $(".js-trigger-mobile-nav").click(function (e) {
                $(".main-nav").fadeToggle(250);
                $(this).toggleClass("is-active");
            });

            /* ==========================================================================
               Search form
               ========================================================================== */

            var isSearchActive = false;

            $(".js-toggle-search").click(function (e) {
                if (isSearchActive) {
                    $(this).parents(".header").find(".header__ekepanuku").delay(250).fadeIn(250);
                    $(this).parents(".search-widget").removeClass("is-active");
                    isSearchActive = false;
                } else {
                    $(this).parents(".header").find(".header__ekepanuku").hide();
                    $(this).parents(".search-widget").find(".search-widget__input").focus();
                    $(this).parents(".search-widget").addClass("is-active");
                    isSearchActive = true;
                }
            });

            /* ==========================================================================
               Slick Sliders
               ========================================================================== */

            $('.js-related-articles-slider').slick({
                fade: false,
                arrows: true,
                dots: false,
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation" id="slick-prev-icon"><use xlink:href="#icon-arrow-left"></use></svg></button>',
                nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation" id="slick-next-icon"><use xlink:href="#icon-arrow-right"></use></svg></button>',
                appendArrows: $(".related-articles-slider__arrows"),
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            });

            $('.js-hero-carousel-slider').slick({
                fade: true,
                arrows: true,
                dots: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation" id="slick-prev-icon"><use xlink:href="#icon-arrow-left"></use></svg></button>',
                nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation" id="slick-next-icon"><use xlink:href="#icon-arrow-right"></use></svg></button>',
                appendArrows: $(".hero-carousel-slider__arrows")
            });

            $(".js-image-slider").each(function () {
                var imageSlider = $(this);
                imageSlider.slick({
                    fade: false,
                    arrows: true,
                    dots: false,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation" id="slick-prev-icon"><use xlink:href="#icon-arrow-left"></use></svg></button>',
                    nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation" id="slick-next-icon"><use xlink:href="#icon-arrow-right"></use></svg></button>',
                    appendArrows: imageSlider.parents(".image-slider-wrapper").find(".image-slider__arrows"),
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            adaptiveHeight: true
                        }
                    }
                    ]
                });
            });

        $(".js-hero-slider").each(function () {
            var imageSlider = $(this);
            imageSlider.slick({
                fade: true,
                arrows: true,
                dots: false,
                infinite: true,
                adaptiveHeight: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation" id="slick-prev-icon"><use xlink:href="#icon-arrow-left"></use></svg></button>',
                nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation" id="slick-next-icon"><use xlink:href="#icon-arrow-right"></use></svg></button>',
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        adaptiveHeight: false
                    }
                }
                ]
            })
            .on('beforeChange', function(event, slick, currentSlide){
                const videoId = 'vimeoVideoContainer_' + currentSlide;
                const video = document.getElementById(videoId);

                if (video) {
                    video.pause();
                }
            })
            .on('afterChange', function(event, slick, currentSlide) {
                const videoId = 'vimeoVideoContainer_' + currentSlide;
                const video = document.getElementById(videoId);

                if (video) {
                    video.play().then(() => {
                        console.log(`Video is now playing: ${videoId}`);
                    })
                    .catch(error => {
                        console.log(`Failed to play video: ${videoId}. Error: ${error}`);
                    });
                }
            });

        });

        window.onSubmit = function(token) {
                let form = $('.subscribe-popup__form');
                $('#recaptcha-response').val(token);

                let data = form.serialize() + '&g-recaptcha-response=' + token;

                $.post('/umbraco/surface/NewsLetterAjax/Subscribe', data)
                    .done(function (response) {
                        $('.subscribe-popup__thanks').show();
                        grecaptcha.reset();
                    })
                    .fail(function (jqXHR, textStatus, error) {
                        // Handle failed validation
                        alert('Failed to submit form: ' + error);
                    });
            }

            function getQueryParam(name) {
                var results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.search);
                return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
            }

            // Check if showNewsLetterSignup parameter is set to true
            if (getQueryParam('showNewsLetterSignup') === 'true') {
                $('.footer-newsletter-button').click();
            }


            /* ==========================================================================
               Home Hero Banner Animation
               ========================================================================== */

            if (document.querySelector('.hero-drawing-animation')) {
                new Vivus('skyline-svg-desktop', {
                    duration: 600,
                    file: 'assets/images/wynyard-quarter-skyline-desktop.svg'
                });
                new Vivus('skyline-svg-mobile', {
                    duration: 400,
                    file: 'assets/images/wynyard-quarter-skyline-mobile.svg'
                });
            }
    }); // document ready

})(window.appJs);


